<script>
	import Chart from 'chart.js';
	import {generateChart, mixins as barChartMixins} from "vue-chartjs";
    import {loadTopMentionImages} from "../../utils";

	const {reactiveProp} = barChartMixins;

	Chart.defaults.TopMentionBarChart = Chart.defaults.bar;

	Chart.controllers.TopMentionBarChart = Chart.controllers.bar.extend({
        async draw() {
			Chart.controllers.bar.prototype.draw.apply(this, arguments);
            let {chart:{ctx}} = this;
			const meta = this.getMeta();
			let imgSize = 30;
			let images = await Promise.all(this.imgUrls);
            let metaData = meta.data.map((item, index) => ({
                ...item._view,
                image: images[index]
            }));
			for(let item of metaData){
				let {x, y , image} = item;
				ctx.save();
                ctx.globalCompositeOperation = 'destination-over';
                ctx.beginPath();
                ctx.arc(x, y - 17, 15, 0, 2*Math.PI);
                ctx.clip();
                ctx.closePath();
                ctx.drawImage(image, x-(imgSize / 2), y - (imgSize + 2), imgSize, imgSize);
                ctx.restore();
			}
		},
        initialize(chart, datasetIndex) {
			Chart.controllers.bar.prototype.initialize.call(this, chart, datasetIndex);
			let imgUrls = chart.config.data.labels.map(label => label.imgUrl);
            this.imgUrls = loadTopMentionImages(imgUrls);
			chart.render();
		}
	});

	const TopMentionBarChart = generateChart('top-mention-bar-chart', 'TopMentionBarChart');

	export default {
		extends: TopMentionBarChart,

		name: "TopMentionBarChart",

		mixins: [reactiveProp],

		props: {
			options: {
				type: Object,
			},
            imgUrl:{
				type:Array
            }
		},

		mounted() {
			this.addPlugin({
                id:"top-mention-barchart-plugin",
				beforeInit(chart) {
					chart.legend.afterFit = function () {
						this.height = this.height + 15;
					}
				}
			});
			this.renderChart(this.chartData, this.options);
		}
	}
</script>
<style>
</style>
